// src/systems/monitoring/features/gis-view/lib/paginate.ts

/** A 1-based page window over a list, plus the "Showing from-to of total" range numbers. */
export interface Page<T> {
  items: T[]
  /** Clamped 1-based page actually shown. */
  page: number
  /** Total number of pages (>= 1, even when empty). */
  pageCount: number
  /** 1-based index of the first item shown (0 when empty). */
  from: number
  /** 1-based index of the last item shown (0 when empty). */
  to: number
  total: number
}

/** Slice `rows` into a clamped 1-based page of `perPage`. Never throws; clamps out-of-range pages. */
export function paginate<T>(rows: T[], page: number, perPage: number): Page<T> {
  const total = rows.length
  const pageCount = Math.max(1, Math.ceil(total / perPage))
  const clamped = Math.min(Math.max(1, Math.trunc(page)), pageCount)
  const start = (clamped - 1) * perPage
  const items = rows.slice(start, start + perPage)
  return {
    items,
    page: clamped,
    pageCount,
    from: total === 0 ? 0 : start + 1,
    to: Math.min(start + perPage, total),
    total,
  }
}
